import axios from 'axios';

export default{
  //  组织架构
  //组织架构保存
  saveTeam(data) {
    return axios.post('/logist/team/save',data);
  },
  //获取组织架构
  getTeam() {
    return axios.get('/logist/team/listTree');
  },
  //删除组织架构
  delTeam(data) {
    return axios.post('/logist/team/delete',data);
  },


  //  物流明星
  //物流明星保存
  saveStar(data) {
    return axios.post('/logist/star/save',data);
  },
  //获取物流明星
  getStar() {
    return axios.get('/logist/star/list');
  },
  //删除物流明星
  delStar(data) {
    return axios.post('/logist/star/delete',data);
  },



  //  物流减排
  //物流减排保存
  saveReduct(data) {
    return axios.post('/logist/reduct/save',data);
  },
  //获取物流减排
  getReduct() {
    return axios.get('/logist/reduct/list');
  },
  //获取物流减排
  getReductDown() {
    return axios.get('/logist/reduct/yearList');
  },
  //删除物流减排
  delReduct(data) {
    return axios.post('/logist/reduct/delete',data);
  },



  //  车辆里程
  //车辆里程保存
  saveCarMile(data) {
    return axios.post('/logist/car/save',data);
  },
  //获取车辆里程
  getCarMile() {
    return axios.get('/logist/car/list');
  },
  //删除车辆里程
  delCarMile(data) {
    return axios.post('/logist/car/delete',data);
  },




  //  车辆状态
  //车辆状态保存
  saveCarState(data) {
    return axios.post('/logist/carState/save',data);
  },
  //获取车辆状态
  getCarState(data) {
    return axios.get('/logist/carState/list?limit=100&status='+data);
  },
  //获取车辆状态List
  getCarStateList() {
    return axios.get('/logist/carState/listStateSize');
  },
  //删除车辆状态
  delCarState(data) {
    return axios.post('/logist/carState/delete',data);
  },




    //  物流提示
  //物流提示保存
  saveNotify(data) {
    return axios.post('/logist/notify/save',data);
  },
  //获取物流提示
  getNotify() {
    return axios.get('/logist/notify/list');
  },
  //删除物流提示
  delNotify(data) {
    return axios.post('/logist/notify/delete',data);
  },






  
}